import React from 'react';

const Footer: React.FC = () => {
  const cols = [
    {
      title: 'Services',
      links: [
        { label: 'Dashboards temps réel', href: '/#services' },
        { label: 'Intégration CRM', href: '/#services' },
        { label: 'Automatisation', href: '/#services' },
        { label: 'IA & LLM', href: '/#services' },
        { label: 'Applications Mobile', href: '/#services' },
      ],
    },
    {
      title: 'Liens rapides',
      links: [
        { label: 'Projets', href: '/projets' },
        { label: 'À propos', href: '/#about' },
        { label: 'Notre Épopée', href: '/#timeline' },
        { label: 'Contact', href: '/#contact' },
      ],
    },
    {
      title: 'Contact',
      links: [
        { label: '+222 34 72 48 48', href: 'tel:+22234724848' },
        { label: '+222 30 70 00 06', href: 'tel:+22230700006' },
        { label: 'contact@miid.mr', href: 'mailto:contact@miid.mr' },
        { label: 'Nouakchott, Mauritanie', href: '/#' },
      ],
    },
  ];

  return (
    <footer
      style={{
        background: 'var(--black)',
        color: '#FFFFFF',
        position: 'relative',
      }}
    >
      {/* Top accent line */}
      <div
        style={{
          height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(184,146,42,.4), transparent)',
        }}
      />

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '4rem 2rem 2.5rem',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
          gap: '2.5rem',
        }}
      >
        {/* Brand column */}
        <div>
          <div
            style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: '2rem',
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: '1rem',
              letterSpacing: '.04em',
            }}
          >
            MIID
          </div>
          <p
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: '.78rem',
              fontWeight: 300,
              color: 'rgba(255,255,255,.55)',
              lineHeight: 1.8,
              marginBottom: '1.2rem',
            }}
          >
            Société Mauritanienne d'Innovation et Développement — votre partenaire technologique de confiance.
          </p>
          <div style={{ display: 'flex', gap: '.5rem' }}>
            {['F', 'in', 'T'].map((icon, i) => (
              <a
                key={i}
                href="/#"
                style={{
                  width: '30px',
                  height: '30px',
                  border: '1px solid rgba(255,255,255,.15)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'rgba(255,255,255,.4)',
                  textDecoration: 'none',
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: '.6rem',
                  fontWeight: 600,
                  transition: 'all .2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = 'var(--gold)';
                  e.currentTarget.style.color = 'var(--gold)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,.15)';
                  e.currentTarget.style.color = 'rgba(255,255,255,.4)';
                }}
              >
                {icon}
              </a>
            ))}
          </div>
        </div>

        {/* Nav columns */}
        {cols.map((col) => (
          <div key={col.title}>
            <h4
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '.6rem',
                fontWeight: 600,
                letterSpacing: '.2em',
                textTransform: 'uppercase',
                color: '#7ED4FA',
                marginBottom: '1.2rem',
              }}
            >
              {col.title}
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '.65rem' }}>
              {col.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: '.75rem',
                      fontWeight: 300,
                      color: 'rgba(255,255,255,.55)',
                      textDecoration: 'none',
                      transition: 'color .2s',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = '#FFFFFF')}
                    onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,.55)')}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div
        style={{
          borderTop: '1px solid rgba(255,255,255,.06)',
          padding: '1.5rem 2rem',
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '1rem',
        }}
      >
        <span
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '.65rem',
            fontWeight: 300,
            color: 'rgba(255,255,255,.3)',
            letterSpacing: '.08em',
          }}
        >
          © 2024 MIID — Société Mauritanienne d'Innovation et Développement
        </span>
        <span
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '.6rem',
            fontWeight: 300,
            color: 'rgba(255,255,255,.25)',
            letterSpacing: '.06em',
          }}
        >
          Tous droits réservés
        </span>
      </div>
    </footer>
  );
};

export default Footer;
